import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetNewsRatingReviewsUseCase extends UseCase {
  constructor({config, httpRatingRepository, newsRatingRequestValueObjectFactory}) {
    super()

    this._config = config
    this._httpRatingRepository = httpRatingRepository
    this._newsRatingRequestValueObjectFactory = newsRatingRequestValueObjectFactory

    this.DEFAULT_RATING_RESPONSE = null
  }

  @tracer({metric: 'GetNewsRatingReviewsUseCase#execute'})
  @inlineError
  async execute({articleId}) {
    const {HAS_RATING_ENABLED} = this._config.get('editorial')
    if (!HAS_RATING_ENABLED) return Promise.resolve(this.DEFAULT_RATING_RESPONSE)

    const [getNewsRatingError, getNewsRatingResponse] = await this._httpRatingRepository.getNewsArticleRating(
      this._newsRatingRequestValueObjectFactory({articleId})
    )

    return getNewsRatingError ? Promise.reject(getNewsRatingError) : getNewsRatingResponse.toJSON()
  }
}
